
import React from 'react'
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Input,
    InputGroup,
    InputGroupText,
    Row,
    Table,
} from "reactstrap";
import { Modal, ModalBody } from "reactstrap";

import { CustomButton } from 'components/CommonInputs/CustomButtons/CustomButton';
// import NavLink from "reactstrap/es/NavLink";
import { Link, NavLink } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
// import AddCandidates from './AddCandidates';
import AddCandidates from './AddCandidates';
import { PageSubHeader } from 'components/CommonLayouts/PageSubHeader';


const ExistingCandidates = () => {
    const navigate = useNavigate();
    const [showAddCandidate, setShowAddCandidate] = React.useState(false);
    const closeModal = () => setShowAddCandidate(false);

    const openModal = () => setShowAddCandidate(true);

    const candidatesDetails = [
        {
            candidateId: "C-001",
            candidateName: "Alice Johnson",
            email: "alice.johnson@example.com",
            mobile: "9123456789",
            role: "Frontend Developer",
            experience: "3"
        },
        {
            candidateId: "C-002",
            candidateName: "Bob Smith",
            email: "bob.smith@example.com",
            mobile: "9234567890",
            role: "Frontend Developer",
            experience: "4"
        },
        {
            candidateId: "C-003",
            candidateName: "Charlie Brown",
            email: "charlie.brown@example.com",
            mobile: "9345678901",
            role: "Frontend Developer",
            experience: "5"
        },
        {
            candidateId: "C-004",
            candidateName: "Diana Prince",
            email: "diana.prince@example.com",
            mobile: "9456789012",
            role: "Frontend Developer",
            experience: "2"
        },
        {
            candidateId: "C-005",
            candidateName: "Ethan Hunt",
            email: "ethan.hunt@example.com",
            mobile: "9567890123",
            role: "Frontend Developer",
            experience: "6"
        },
        {
            candidateId: "C-006",
            candidateName: "Fiona Gallagher",
            email: "fiona.gallagher@example.com",
            mobile: "9678901234",
            role: "Frontend Developer",
            experience: "3"
        },
        {
            candidateId: "C-007",
            candidateName: "George Martin",
            email: "george.martin@example.com",
            mobile: "9789012345",
            role: "Frontend Developer",
            experience: "7"
        }
    ];



    return (
        <div className='page-content'>
            <Container fluid className="py-0 px-0">
                <PageSubHeader
                          
                          heading={"Add Candidates"}
                          PageSubHeader={"Discover Open Roles. Align Candidates. Boost Submissions."}
                          routePath={"Home"}
                          pageName={"Add Candidates"} />
                <Row className='px-4 py-4'>
                    {/* <Row className="py-2 px-4">
                        <Col><p className='sub-heading'>View Job Postings/ JD1023/ View Post/ Add Candidates</p>
                            <h2 className='heading'>Add Candidates</h2></Col>
                        <Col
                            xs={4}
                            className="d-flex align-items-center justify-content-end"
                        >
                            <Button
                                //   color="primary"
                                //   outline
                                //   className="waves-effect waves-light"
                                style={{ backgroundColor: "#006438", color: "#FFFFFF", borderRadius: "12px" }}
                            //   onClick={() => navigate("/add-candidates")}

                            >
                                Submit
                            </Button>

                        </Col>
                    </Row> */}


                    <Row className='p-2'>

                        <Col className='d-flex  '>
                            <InputGroup size="sm" style={{ width: "348px" }} className="elbert-search-group">
                                <Input placeholder="Search by candidate name" className="elbert-search" />
                                <InputGroupText>
                                    <span className="fa fa-search"></span>
                                </InputGroupText>
                            </InputGroup>
                            <Input type='select' style={{ width: "125px", marginLeft: "16px" }}>
                                <option value="">Status</option>
                            </Input>

                            <Input type='select' style={{ width: "125px", marginLeft: "16px" }}>
                                <option>Frontend</option></Input>
                            <Input type='select' style={{ width: "137px", marginLeft: "16px" }}>
                                <option>Experience </option></Input>
                        </Col>
                        <Col
                            xs={4}
                            className="d-flex align-items-center justify-content-end"
                        >
                            <Button
                                //   color="primary"
                                //   outline
                                //   className="waves-effect waves-light"
                                style={{ backgroundColor: "#006438", color: "#FFFFFF", borderRadius: "12px" }}
                            //   onClick={() => navigate("/add-candidates")}

                            >
                                Submit
                            </Button>

                        </Col>
                    </Row>
                    <Row className="mt-4 px-4">
                        <Card>
                            <CardBody>
                                <div className="table-responsive ">
                                    <Table className="table mb-0 border: 0.4px solid #D4D4D4;">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Candidate ID</th>
                                                <th>Candidate Name</th>
                                                <th>Email</th>
                                                <th>Mobile</th>
                                                <th>Role</th>
                                                <th>Experience</th>
                                                <th>Resume</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {candidatesDetails.map((candidate) => (
                                                <tr key={candidate.id}>
                                                    <td ><Input type='checkbox'style={{width:"17px",height:"17px"}} ></Input></td>
                                                    <td>{candidate.candidateId}</td>
                                                    <td>{candidate.candidateName}</td>
                                                    <td>{candidate.email}</td>
                                                    <td>{candidate.mobile}</td>
                                                    <td>{candidate.role}</td>
                                                    <td>{candidate.experience}</td>

                                                    {/* <td>{candidate.resume}</td> */}

                                                    <td><i
                                                        className="fa-solid fa-paperclip"
                                                        title="Attach"
                                                        style={{ color: '#1E9EFB', transform: 'rotate(-45deg)', fontSize: '19px',marginLeft:"5px" }}
                                                    ></i></td>


                                                    <td>
                                                        <div className="d-flex gap-2 ">
                                                            <i className="fa-solid fa-eye action-icon" title="View" style={{ cursor: "pointer", display: "flex", justifyContent: "center", marginLeft:"5px"}}
                                                                // onClick={() => navigate('/view-candidate-progress')}
                                                                >
                                                                    
                                                                </i>

                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </CardBody>
                        </Card>
                    </Row>


                </Row>
            </Container>

        </div>
    );
};

export default ExistingCandidates;
